import { Button } from "@dmm-com/rocket-web-ui-library";
import { memo } from "react";
import * as Styled from "./style";
import type { VideoLegacySeasonType } from "~/components/blocks/product/type-guard";
import { useMatchMedia } from "~/hooks/use-match-media";

type Vod2dProps = {
  parts: VideoLegacySeasonType["content"]["playInfo"]["parts"];
  handleVod2DPartBtnPressed: (contentId: string, partNumber: number) => void;
};

export const Vod2d = memo((props: Vod2dProps) => {
  const { parts, handleVod2DPartBtnPressed } = props;

  const { isSpSize } = useMatchMedia();

  if (parts.length <= 1) return null;

  return (
    <Styled.DivFlexContainer>
      <Styled.DivGridButtonSpace>
        {parts.map((item, idx) => {
          return (
            <Button
              key={`PartButton-${idx}`}
              name="パートボタン"
              mainText={isSpSize ? `${item.number}` : `パート${item.number}`}
              iconName="play"
              iconColor="GRAY50"
              iconSize={isSpSize ? "L" : "XL"}
              fontSize={isSpSize ? "S" : "M"}
              color="GRAY50"
              bgColor="YELLOW900"
              onClick={() => handleVod2DPartBtnPressed(item.contentId, item.number)}
            />
          );
        })}
      </Styled.DivGridButtonSpace>
    </Styled.DivFlexContainer>
  );
});

Vod2d.displayName = "Vod2d";
